const sizeConfigs = {
  sidebar: {
    width: "350px",
  },
  topbar: {
    height: "50px",
  },
  footer: { // TODO: see Footer.tsx
    height: "40px",
  }
};

export default sizeConfigs;